import BaseChart from './BaseChart';

/**
 * Gauge chart implementation using VChart
 */
class GaugeChart extends BaseChart {
  /**
   * Get chart specification for gauge chart
   * @returns {Object} Chart specification
   */
  getChartSpecification() {
    const commonConfig = this.getCommonConfig();
    const data = this.prepareData();
    
    const value = this.data.value ?? (Array.isArray(this.data) ? this.data[0]?.value : 0);
    const min = this.options.min ?? 0;
    const max = this.options.max ?? 100;
    const startAngle = this.options.startAngle ?? -Math.PI * 0.75;
    const endAngle = this.options.endAngle ?? Math.PI * 0.75;
    
    return {
      type: 'gauge',
      data,
      value,
      min,
      max,
      startAngle,
      endAngle,
      
      // Gauge axis bands for different value ranges
      axisBands: this.options.axisBands || [
        {
          range: [0, max * 0.6],
          style: {
            fill: '#52c41a'
          }
        },
        {
          range: [max * 0.6, max * 0.8],
          style: {
            fill: '#faad14'
          }
        },
        {
          range: [max * 0.8, max],
          style: {
            fill: '#f5222d'
          }
        }
      ],
      
      // Pointer configuration
      pointer: {
        style: {
          fill: '#1890ff',
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.pointerStyle
        },
        ...this.options.pointer
      },
      
      // Pin configuration (center point)
      pin: {
        style: {
          fill: '#1890ff',
          stroke: '#fff',
          lineWidth: 1,
          ...this.options.pinStyle
        },
        ...this.options.pin
      },
      
      // Label configuration
      label: {
        visible: this.options.showLabel !== false,
        formatter: this.options.labelFormatter || (value => `${value}`),
        style: {
          fontSize: 24,
          fontWeight: 'bold',
          ...this.options.labelStyle
        },
        ...this.options.label
      },
      
      // Animation configuration
      animationAppear: {
        duration: 800,
        easing: 'cubicOut',
        ...this.options.animationAppear
      },
      
      // Common configuration from BaseChart
      ...commonConfig
    };
  }
  
  /**
   * Prepare data for VChart format
   * @returns {Array} Formatted data for VChart
   */
  prepareData() {
    // Gauge chart expects specific data format
    return [
      {
        id: 'gaugeData',
        values: this.data
      }
    ];
  }
}

export default GaugeChart; 